import { NgModule } from '@angular/core';
import { BootstrapModule, BootstrapModuleContract, DatatablesModule, FormsModule, MenuService, SupportModule } from '@kaiser-software/chassis-core';
import { LocationService } from './services/location.service';
import { LocationSettingsPlugin } from './plugins/location-settings/location-settings.plugin';
import { LocationsRoutingModule } from './locations-routing.module';

@NgModule({
    imports: [
        FormsModule,
        DatatablesModule,
        SupportModule,
        LocationsRoutingModule
    ],
    declarations: [
        LocationSettingsPlugin
    ],
    entryComponents: [
        LocationSettingsPlugin
    ],
    providers: [
        LocationService
    ],
    exports: [
        LocationSettingsPlugin
    ]
})
export class LocationsModule extends BootstrapModule implements BootstrapModuleContract {

    public menus(menus: MenuService) {
        const sidebar = menus.get('sidebar');

        const settings = sidebar.get('settings');

        settings.add('locations.index', 'Locations', 'locations.index', {
            icon: 'fa fa-home',
            order: 30,
            permission: 'location.read'
        });
    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/locations/locations.module.ts